import { SubscriptionPaymentType } from '../enums/subscription-payment-type.enum';
import { SubscriptionStatus } from '../enums/subscription-status.enum';
import { Coupon } from './coupon.model';
import { Plan, Module } from './plan.model';

export class Subscription {
	id: number;
	plan: Plan;
	startDate: number;
	endDate: number;
	total: number;
	status: SubscriptionStatus;
	coupon: string;
	subscriptionModules: SubscriptionModule[];
	discount: number;
	subscriptionApiId: string;
	paymentType: SubscriptionPaymentType;
	invoiceDetails: Invoice | string;
	couponInfo: Coupon;

	subscriptionTotal: number;

	constructor(obj: any = { }) {
		Object.assign(this, obj);

		this.plan = new Plan(obj.plan);
		if (obj.invoiceDetails && typeof obj.invoiceDetails == "string") {
			this.invoiceDetails = JSON.parse(obj.invoiceDetails);
		}

		this.subscriptionTotal = this.calculateSubscriptionTotal();
	}

	private calculateSubscriptionTotal(): number {
		let total: number = 0
		if (this.subscriptionModules && this.subscriptionModules.length > 0) {
			this.subscriptionModules.forEach((m) => {
				total += m.modules.price || 0;
			});
		}
		total += this.plan.price || 0;
		return total;
	}
}

/**
 * Invoice no formato da iugu
 */
export class Invoice {
	id: string;
	dueDate: string;
	status: string;
	total: string;
	secureUrl: string;
	statusCode: number;
}

export interface SubscriptionModule {
	id: number;
	modules: Module;
	extra: boolean;
}

export interface ModulesInTestToShow {
	count: number;
	nextModulesToExpireCount: number;
	nextModulesToExpireDate: string;
	hasSubscriptionProblem: boolean;
	allModulesExpired: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/subscription.model.ts